import { render, staticRenderFns } from "./UserReactions.vue?vue&type=template&id=249e0c47&scoped=true"
import script from "./UserReactions.vue?vue&type=script&lang=js"
export * from "./UserReactions.vue?vue&type=script&lang=js"
import style0 from "./UserReactions.vue?vue&type=style&index=0&id=249e0c47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249e0c47",
  null
  
)

export default component.exports